export class Enums {

    checkListEntryType = {
            registered_voters: 'Registered voters',
            accredited_voters: 'Accredited voters',
            verified_voters_from_cr: 'Verified voters from BVAS',
            disputed_voters: 'Disputed voters',
            rejected_voters: 'Rejected voters',
            user_defined_1: 'User Defined 1st',
            user_defined_2: 'User Defined 2nd',
    };

    checkListSubType = {
            audio: 'Audio',
            document: 'Document',
            entry: 'Entry',
            image: 'Photo',
            other: 'Comment',
            video: 'Video',
            yes_no: 'Yes/No',
			date: 'Date',
			time: 'Time',
			number: 'Number',
    };

    checkListType = {
            polling_unit: 'Polling Unit',
            collation: 'Collation',
    };

    electionLevel = {
            federal: 'Federal',
            state: 'State',
            senatorial_district: 'Senatorial District',
            state_constituency: 'State Constituency',
            federal_constituency: 'Federal Constituency',
            local_government_area: 'LGA',
            ward: 'Wards',
            polling_unit: 'No Position',
    };

    permissionType = {
            view: 'view',
            add: 'add',
            edit: 'edit',
            delete: 'delete',
    };

    userLevel = {
            superadmin: 'Super admin',
            party: 'Federal',
            state: 'State',
            lga: 'LGA',
            senatorial_district: 'Senatorial District',
            federal_constituency: 'Federal Constituency',
            state_constituency: 'State Constituency',
            ward: 'Ward',
            polling_unit: 'Polling Unit',
    };
	
	userPlLevel = {
            polling_unit: 'Polling Unit',
    };

    userType = {
            superuser: 'Super User',
            party_user: 'Party User',
    };

    yesNoType = {
            1: 'Yes',
            0: 'No',
    };

}

export const enums = new Enums();


// WEBPACK FOOTER //
// ./resources/js/Enums.ts